import { Icon } from "@blueprintjs/core";

import { unescape } from "@/components/helpers/string-utils";
import { Box, BoxProps, Flex } from "@/components/layout/flexbox";
import { decodeHtmlEntities } from "@/components/pages_logged_in/roleplays/details/scenario/Notes";
import { ExpandableAnswer, Truncate } from "@/components/pieces/Truncate";
import { SUBTEXT_COLOR } from "@/css/constants";
import { FullMeeting, FullReview } from "@/types/meetings";
import { NonNullableArrayItem } from "@/utils/types";

type MeetingAnswer = NonNullableArrayItem<
  NonNullable<FullMeeting["formFieldAnswers"]>
>;
type ReviewAnswer = NonNullableArrayItem<
  NonNullable<FullReview["formFieldAnswers"]>
>;
type FormFieldAnswer = MeetingAnswer | ReviewAnswer;

interface SubmittedInfoProps extends BoxProps {
  answers: FormFieldAnswer[];
}

export function SubmittedInfo({ answers, ...props }: SubmittedInfoProps) {
  return (
    <Box className="round-corners" py={3} {...props}>
      {answers.map((answer, index) => {
        return (
          <Box key={answer.id} mt={index > 0 ? 3 : undefined}>
            <Box fontWeight={600} color={SUBTEXT_COLOR} fontSize={16}>
              {answer.formField?.prompt}
            </Box>
            <Box mt={1} fontSize={16}>
              {answer.userFile ? (
                <Flex alignItems="center">
                  <Icon icon="paperclip" color={SUBTEXT_COLOR} />
                  <Box ml={1}>
                    <a href={answer.userFile.url} target="_BLANK">
                      <Truncate>{answer.userFile.name}</Truncate>
                    </a>
                  </Box>
                </Flex>
              ) : (
                <Box style={{ whiteSpace: "pre-line" }}>
                  <ExpandableAnswer
                    value={unescape(
                      decodeHtmlEntities(
                        answer?.value || answer?.optionValue?.label || "",
                      ),
                    )}
                    replaceLinks={true}
                    maxLength={85}
                  />
                </Box>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
